import { asFunction } from "@/_di/resolvers";
import { FacilityUseCases, facilityUseCases } from "@/core/facility/useCases/facilityUseCases";
import { apiFacilityRepository } from "@/core/facility/infraestructure/apiFacilityRepository";
import { FacilityRepository } from "@/core/facility/domain/facilityRepository";

export const facilityModule = {
  facilityUseCases: asFunction<FacilityUseCases>(facilityUseCases),
  facilityRepository: asFunction<FacilityRepository>(apiFacilityRepository),
};
